module.exports = __webpack_public_path__ + "static/partnership_img5@2x-f14fd9857cc49cc9ea9d374a54853b07.jpg";